@if (serverError || showInlineErrorMessage) {
<cui-notification-banner type="error" [hasBottomBorder]="hasBottomBorder">
  @if (serverError) { @if (serverError.error?.attributeErrors) {
  <div class="mb-bl-1" data-pgr-id="attribute-error-message">
    Please correct the following errors:
  </div>
  <ul class="error-list" data-pgr-id="attribute-errors">
    @for (attributeError of serverError.error.attributeErrors; track
    attributeError) {
    <li>
      {{ attributeError.attributeName }}
      {{ attributeError.attributeDisplayMessage }}
    </li>
    }
  </ul>
  } @else { @if (serverError?.error?.baseErrorMessage) {
  <div class="mb-bl-1" data-pgr-id="status-text-message">
    The following errors occurred, please try again:
  </div>
  <ul class="error-list">
    <li data-pgr-id="server-error-status-text">
      {{ serverError.error.baseErrorMessage }}
    </li>
  </ul>
  } @else { @if (serverError.statusText) {
  <div class="mb-bl-1" data-pgr-id="status-text-message">
    The following errors occurred, please try again:
  </div>
  <ul class="error-list">
    <li data-pgr-id="server-error-status-text">
      {{ serverError.statusText }}
    </li>
  </ul>
  } @else {
  <span data-pgr-id="default-server-banner-message"
    >An unexpected error occurred. Please try again.</span
  >
  } } } } @if (showInlineErrorMessage) {
  <span data-pgr-id="inline-error-message"
    >Please correct the errors below to continue.</span
  >
  }
</cui-notification-banner>
}
